import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import Logout from './Logout'
import LandingPage from './LandingPage'
import Logo from './Logo'
import {
    MaxWidthWrapper,
    PageContentWrapperSection,
} from '../../components/LayoutContainer.ui'
import LogoLink from './Logo'
import InvitationAcceptPage from './InvitationAcceptPage'
import VerificationPending from './VerificationPending'
import PasswordReset from './PasswordReset'
import Loading from '../../components/Loading'
import PrivacyPolicy from './Privacy'
import PublicTeamsOverviewPage from './Teams'
const Login = React.lazy(() => import('./Login'))
const Signup = React.lazy(() => import('./Signup'))
const AboutPage = React.lazy(() => import('./About'))
const Features = React.lazy(() => import('./Features'))
const withSuspense = (Component) => (props) =>
    (
        <Suspense fallback={<Loading />}>
            <Component {...props} />
        </Suspense>
    )
const withWrapPage = (Component) => (props) =>
    (
        <PageContentWrapperSection style={{ padding: '1.5rem' }}>
            <MaxWidthWrapper style={{ paddingBottom: '1rem' }}>
                {!props?.noLogo && <LogoLink />}
                <Component {...props} />
            </MaxWidthWrapper>
        </PageContentWrapperSection>
    )
const SignupComplete = () => (
    <>
        <h4>Signup Complete, login below</h4>
        <Login></Login>
    </>
)
const PublicPages = () => {
    return (
        <Routes>
            <Route path="/" exact element={<LandingPage />}></Route>
            <Route
                path="/login"
                element={withWrapPage(withSuspense(Login))()}
            ></Route>
            <Route
                path="/signup"
                element={withWrapPage(withSuspense(Signup))()}
            ></Route>
            <Route
                path="/features/*"
                element={withWrapPage(withSuspense(Features))()}
            ></Route>
            <Route
                path="/about"
                element={withWrapPage(withSuspense(AboutPage))()}
            ></Route>
            <Route
                path="/invitations/:token"
                element={withWrapPage(InvitationAcceptPage)()}
            ></Route>
            <Route path="/logout" element={<Logout />} />
            <Route path="/logo" element={withWrapPage(Logo)()} />
            <Route
                path="/privacy"
                element={withWrapPage(PrivacyPolicy)()}
            ></Route>
            <Route
                path="/pending-verification"
                element={withWrapPage(VerificationPending)()}
            />
            <Route
                path="/signup-complete"
                element={withWrapPage(withSuspense(SignupComplete))()}
            />
            <Route
                path="/password-reset-sent"
                element={withWrapPage(
                    withSuspense(() => (
                        <>
                            <h4>Reset Password sent </h4>
                            <p>
                                Check your mailbox and click the link to reset
                                your password
                            </p>
                            <Login></Login>
                        </>
                    ))
                )()}
            />
            <Route
                path="/reset-password/:token"
                element={withWrapPage(PasswordReset)()}
            />
            <Route
                path="/teams/*"
                element={<PublicTeamsOverviewPage />}
            ></Route>
            <Route path="/my/*" element={<h1>not logged in</h1>}></Route>
        </Routes>
    )
}

export default PublicPages
